module.exports = __webpack_public_path__ + "static/media/Arif.4959932d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/Arif.jpg
// module id = 1767
// module chunks = 147